import React, { Component } from "react";
import { registerForLocalization, provideLocalizationService } from "@progress/kendo-react-intl";
import LoadingPanel from "../../common/LoadingPanel";
import { dateConvert } from "../../common/Helpers";
import BalikyGrid from "../../views/Home/BalikyGrid";
import { odoslanieDodavkyController } from "../../../controllers/odoslaniedodavky.controller";
import { DropDownButton, DropDownButtonItem } from "@progress/kendo-react-buttons";
import { MessageTypeEnum, ButtonGroupEnum, ButtonMessageEnum, RoleNames, SposobDopravy } from "../../../enums";
import confirmService from "../../common/confirmService";
import { sestavyController } from "../../../controllers/sestavy.controller";
import { balikArtikleController } from "../../../controllers/balikartikle.controller";
import DialogWindow from "../../common/DialogWindow";
import PdfViewer from "../../common/PdfViewer";
import { authenticationService } from "../../../services/authentication.service";
import { expediciaController } from "../../../controllers/expedicia.controller";
import BalikArtikleDialogContent from "../BalikArtikleDialogContent";
import vyberPoziceGlsStitkyService from "../../common/vyberPoziceGlsStitkyService";

class OdoslanieBaliky extends Component {
    state = {
        items: [],
        loading: true,
        selectedDodavkaId: this.props.selectedDodavkaId,
        selectedSposobDopravy: this.props.selectedSposobDopravy,
        selectedBalikIds: [],
        pdfShow: false,
        pdfLoading: false,
        pdfPrint: true,
        pdfFile: null
    };

    shouldComponentUpdate(nextProps) {
        if (this.props.selectedDodavkaId !== nextProps.selectedDodavkaId) {
            this.getOdoslanieBalikyByDodavkaId(nextProps.selectedDodavkaId);
            return false;
        }
        return true;
    }

    componentDidMount() {
        this.getOdoslanieBalikyByDodavkaId(this.props.selectedDodavkaId);
    }

    getOdoslanieBalikyByDodavkaId(dodavkaId) {
        odoslanieDodavkyController.getBalikyByDodavkaId(dodavkaId).then((response) => {
            let data = JSON.parse(JSON.stringify(response), dateConvert);
            this.setState({
                selectedDodavkaId: dodavkaId,
                selectedSposobDopravy: null,
                selectedBalikIds: [],
                items: data,
                loading: false
            });
        });
    }

    changeSelectedBalikPaleta = (balikIds) => {
        this.setState({
            selectedDodavkaId: this.props.selectedDodavkaId,
            selectedSposobDopravy: this.props.selectedSposobDopravy,
            selectedBalikIds: balikIds
        });
    };

    printDodaciList = (balikId) => {
        this.setState({
            pdfShow: true,
            pdfLoading: true
        });

        sestavyController.GetDodaciList(balikId, true, (fileURL) => {
            this.setState({
                pdfLoading: false,
                pdfPrint: true,
                pdfFile: fileURL
            });
        });
    };

    printBalikStitek = (balikId) => {
        this.setState({
            pdfShow: true,
            pdfLoading: true
        });

        sestavyController.GetBalikStitek(balikId, (fileURL) => {
            this.setState({
                pdfLoading: false,
                pdfPrint: true,
                pdfFile: fileURL
            });
        });
    };

    printGlsBalikStitek = async (balikId) => {
        var localizationService = provideLocalizationService(this);

        this.setState({
            pdfShow: true,
            pdfLoading: true
        });

        const result = await vyberPoziceGlsStitkyService.show({ logMessage: true });
        if (result.button == ButtonMessageEnum.OK) {
            sestavyController.GetGlsBalikStitek(
                balikId,
                result.value,
                (fileURL) => {
                    this.setState({
                        pdfLoading: false,
                        pdfPrint: true,
                        pdfFile: fileURL
                    });
                    this.getOdoslanieBalikyByDodavkaId(this.state.selectedDodavkaId);
                },
                async (errorMessage) => {
                    this.setState({
                        pdfLoading: false,
                        pdfShow: false,
                        pdfPrint: false,
                        pdfFile: null
                    });
                    await confirmService.show({
                        type: MessageTypeEnum.CRITICAL,
                        message:
                            localizationService.toLanguageString("OdoslanieBaliky.Chyba při generování GLS štítku.", "Chyba při generování GLS štítku.") +
                            "\n\n" +
                            errorMessage
                    });
                }
            );
        } else {
            this.setState({
                pdfLoading: false,
                pdfShow: false,
                pdfPrint: false,
                pdfFile: null
            });
        }
    };

    printPotvrdeniePreVodica = (idExpedicia) => {
        this.setState({
            pdfShow: true,
            pdfLoading: true
        });
        sestavyController.GetPotvrzeniProRidice(idExpedicia, true, (fileURL) => {
            this.setState({
                pdfLoading: false,
                pdfPrint: true,
                pdfFile: fileURL
            });
        });
    };

    printDodaciListOdeslaniTovaru = (idExpedicia) => {
        this.setState({
            pdfShow: true,
            pdfLoading: true
        });
        sestavyController.GetDodaciListOdeslaniTovaru(idExpedicia, true, (fileURL) => {
            this.setState({
                pdfLoading: false,
                pdfPrint: true,
                pdfFile: fileURL
            });
        });
    };
    printSouhrnyDodaciList = (idExpedicia) => {
        this.setState({
            pdfShow: true,
            pdfLoading: true
        });
        sestavyController.GetSouhrnyDodaciList(idExpedicia, true, (fileURL) => {
            this.setState({
                pdfLoading: false,
                pdfPrint: true,
                pdfFile: fileURL
            });
        });
    };

    reloadGrid = (handleReloaded) => {
        if (handleReloaded) {
            handleReloaded();
        }
    };

    openBalikArtikleDialog(title, idBalik) {
        this.setState({
            dialog: {
                title: title,
                hasClosingConfirmDialog: true,
                content: (onClose, showClosingConfirmDialog, allowOpeningConfirmDialog, toggleErrorDialog, closeConfirmDialog) => (
                    <BalikArtikleDialogContent
                        idBalik={idBalik}
                        toggleDialog={onClose}
                        reloadGrid={(handleReloaded) => {
                            this.reloadGrid(handleReloaded);
                        }}
                        printBalikStitek={this.printBalikStitek}
                        // selectSavedBalikPaleta={this.selectSavedBalikPaleta}
                        showClosingConfirmDialog={showClosingConfirmDialog}
                        balikIsChanged={allowOpeningConfirmDialog}
                        showErrorDialog={toggleErrorDialog}
                        closeConfirmDialog={closeConfirmDialog}
                    />
                ),
                height: "740px",
                width: "722px"
            }
        });
    }

    deleteBalik = async (idBalik) => {
        balikArtikleController.ValidateDeletedBalik(idBalik).then(async (response) => {
            if (response.errorMessage) {
                await confirmService.show({
                    type: response.messageType,
                    message: response.errorMessage
                });
            } else {
                const confirmResult = await confirmService.show({
                    type: MessageTypeEnum.QUESTION,
                    message: response.confirmMessage,
                    buttons: ButtonGroupEnum.YES_NO
                });
                if (confirmResult == ButtonMessageEnum.YES) {
                    await this.deleteBalikUplne(response.idBalik);
                }
            }
        });
    };

    deleteBalikUplne = async (idBalik) => {
        balikArtikleController.DeleteBalik(idBalik).then(async (response) => {
            if (response.errorMessage) {
                await confirmService.show({
                    type: MessageTypeEnum.CRITICAL,
                    message: response.errorMessage
                });
            } else {
                // TODO: this.reloadGrid();
                this.props.reloadOdoslanieGrids();
            }
        });
    };

    deleteExpedicia = async (idExpedicia) => {
        const confirmResult = await confirmService.show({
            type: MessageTypeEnum.EXCLAMATION,
            message: `Naozaj chcete odstrániť expedíciu č.${idExpedicia} ?`,
            buttons: ButtonGroupEnum.YES_NO
        });
        if (confirmResult == ButtonMessageEnum.YES) {
            await this.deleteExpediciaUplne(idExpedicia);
        }
    };

    vygenerovatSpravu = async (idExpedicia) => {
        const confirmResult = await confirmService.show({
            type: MessageTypeEnum.EXCLAMATION,
            message: `Naozaj chcete vygenerovať chýbajúcu správu pre expedíciu č.${idExpedicia} ?`,
            buttons: ButtonGroupEnum.YES_NO
        });
        if (confirmResult == ButtonMessageEnum.YES) {
            await expediciaController.vytvoritSpravu(idExpedicia).then(async (response) => {
                if (response.errorMessage) {
                    await confirmService.show({
                        type: MessageTypeEnum.CRITICAL,
                        message: response.errorMessage
                    });
                } else {
                    this.props.reloadOdoslanieGrids();
                }
            });
        }
    };

    deleteExpediciaUplne = async (idExpedicia) => {
        expediciaController.deleteExpedicia(idExpedicia).then(async (response) => {
            if (response.errorMessage) {
                await confirmService.show({
                    type: MessageTypeEnum.CRITICAL,
                    message: response.errorMessage
                });
            } else {
                // TODO: this.reloadGrid();
                this.props.reloadOdoslanieGrids();
            }
        });
    };

    async handleMoznostiItemClick(event) {
        var localizationService = provideLocalizationService(this);

        switch (event.itemIndex) {
            case 0:
                if (this.state.selectedBalikIds.length != 1) {
                    await confirmService.show({
                        type: MessageTypeEnum.EXCLAMATION,
                        message: localizationService.toLanguageString(
                            "OdoFRM.Zo zoznamu neexpedovaných balíkov vyberte jeden balík, ktorý chcete upraviť !",
                            "Zo zoznamu neexpedovaných balíkov vyberte jeden balík, ktorý chcete upraviť !"
                        )
                    });
                } else {
                    this.printDodaciList(this.state.selectedBalikIds[0]);
                }
                break;
            case 1: // Vytlačiť kópiu štítku na balík
                if (this.state.selectedBalikIds.length != 1) {
                    await confirmService.show({
                        type: MessageTypeEnum.EXCLAMATION,
                        message: localizationService.toLanguageString("OdoFRM.Vyberte balík zo zoznamu !", "Vyberte balík zo zoznamu !")
                    });
                } else {
                    this.printBalikStitek(this.state.selectedBalikIds[0]);
                }
                break;
            case 2: // Vytlačiť kópiu GLS štítku na balík
                if (this.state.selectedBalikIds.length != 1) {
                    await confirmService.show({
                        type: MessageTypeEnum.EXCLAMATION,
                        message: localizationService.toLanguageString("OdoFRM.Vyberte balík zo zoznamu !", "Vyberte balík zo zoznamu !")
                    });
                } else {
                    this.printGlsBalikStitek(this.state.selectedBalikIds[0]);
                }
                break;
            case 3: // Vytlačiť kópiu súhrnného dodacieho listu
                if (!this.props.selectedExpediciaId || this.props.selectedExpediciaId == 500000000 || !this.state.selectedDodavkaId) {
                    await confirmService.show({
                        type: MessageTypeEnum.EXCLAMATION,
                        message: localizationService.toLanguageString("OdoFRM.Vyberte dodávku zo zoznamu !", "Vyberte dodávku zo zoznamu !")
                    });
                } else {
                    this.printSouhrnyDodaciList(this.props.selectedExpediciaId);
                }
                break;
            case 4: // Vytlačiť kópiu potvrdenia o prevzatí dodávky tovaru
                if (!this.props.selectedExpediciaId || this.props.selectedExpediciaId == 500000000 || !this.state.selectedDodavkaId) {
                    await confirmService.show({
                        type: MessageTypeEnum.EXCLAMATION,
                        message: localizationService.toLanguageString("OdoFRM.Vyberte dodávku zo zoznamu !", "Vyberte dodávku zo zoznamu !")
                    });
                } else {
                    this.printPotvrdeniePreVodica(this.props.selectedExpediciaId);
                }
                break;
            case 5: // Vytlačiť kópiu dodacieho listu pre odoslanie tovaru
                if (!this.props.selectedExpediciaId || this.props.selectedExpediciaId == 500000000 || !this.state.selectedDodavkaId) {
                    await confirmService.show({
                        type: MessageTypeEnum.EXCLAMATION,
                        message: localizationService.toLanguageString("OdoFRM.Vyberte dodávku zo zoznamu !", "Vyberte dodávku zo zoznamu !")
                    });
                } else {
                    this.printDodaciListOdeslaniTovaru(this.props.selectedExpediciaId);
                }
                break;
            case 6: // Upraviť neexpedovaný balík
                if (this.state.selectedBalikIds.length != 1) {
                    await confirmService.show({
                        type: MessageTypeEnum.EXCLAMATION,
                        message: localizationService.toLanguageString(
                            "OdoFRM.Zo zoznamu neexpedovaných balíkov vyberte jeden balík, ktorý chcete upraviť !",
                            "Zo zoznamu neexpedovaných balíkov vyberte jeden balík, ktorý chcete upraviť !"
                        )
                    });
                } else {
                    this.openBalikArtikleDialog(
                        localizationService.toLanguageString("BalíkFRM.Úprava balíka", "Úprava balíka"),
                        this.state.selectedBalikIds[0]
                    );
                }
                break;
            case 7: // Odstrániť neexpedovaný balík
                if (this.state.selectedBalikIds.length != 1) {
                    await confirmService.show({
                        type: MessageTypeEnum.EXCLAMATION,
                        message: localizationService.toLanguageString(
                            "OdoFRM.Zo zoznamu neexpedovaných balíkov vyberte jeden balík, ktorý chcete odstrániť !",
                            "Zo zoznamu neexpedovaných balíkov vyberte jeden balík, ktorý chcete odstrániť !"
                        )
                    });
                } else {
                    this.deleteBalik(this.state.selectedBalikIds[0]);
                }
                break;
            case 8: // Odstrániť expedíciu tovaru
                if (authenticationService.currentUzivatelMeno != "Jaro") {
                    await confirmService.show({
                        type: MessageTypeEnum.CRITICAL,
                        message: localizationService.toLanguageString(
                            "OdoFRM.Nemáte oprávnenie odstrániť expedíciu tovaru !",
                            "Nemáte oprávnenie odstrániť expedíciu tovaru !"
                        )
                    });
                } else if (!this.props.selectedExpediciaId || this.props.selectedExpediciaId == 500000000 || !this.state.selectedDodavkaId) {
                    await confirmService.show({
                        type: MessageTypeEnum.EXCLAMATION,
                        message: localizationService.toLanguageString(
                            "OdoFRM.Vyberte expedíciu zo zoznamu dodávok tovaru !",
                            "Vyberte expedíciu zo zoznamu dodávok tovaru !"
                        )
                    });
                } else {
                    this.deleteExpedicia(this.props.selectedExpediciaId);
                }
                break;
            case 9: // Vygenerovat správu expedice
                if (!authenticationService.hasCurrentUserRole(RoleNames.Administrator)) {
                    await confirmService.show({
                        type: MessageTypeEnum.CRITICAL,
                        message: localizationService.toLanguageString(
                            "OdoFRM.Nemáte oprávnenie vygenerovať chýbajúcu správu pre expedíciu tovaru !",
                            "Nemáte oprávnenie vygenerovať chýbajúcu správu pre expedíciu tovaru !"
                        )
                    });
                } else if (!this.props.selectedExpediciaId || this.props.selectedExpediciaId == 500000000 || !this.state.selectedDodavkaId) {
                    await confirmService.show({
                        type: MessageTypeEnum.EXCLAMATION,
                        message: localizationService.toLanguageString(
                            "OdoFRM.Vyberte expedíciu zo zoznamu dodávok tovaru !",
                            "Vyberte expedíciu zo zoznamu dodávok tovaru !"
                        )
                    });
                } else {
                    this.vygenerovatSpravu(this.props.selectedExpediciaId);
                }
                break;
        }
    }

    render() {
        var localizationService = provideLocalizationService(this);
        let contents = this.state.loading ? (
            <LoadingPanel />
        ) : (
            <React.Fragment>
                <BalikyGrid
                    items={this.state.items}
                    pageable={{ buttonCount: 0, info: true, pageSizes: false, previousNext: false }}
                    changeSelectedBalikPaleta={this.changeSelectedBalikPaleta}
                    showParcelNumber={true}
                />
                <div className="text-right">
                    <DropDownButton
                        text={localizationService.toLanguageString("MenuFRM.Možnosti", "Možnosti")}
                        icon="menu"
                        className="auto-focus"
                        onItemClick={(e) => this.handleMoznostiItemClick(e)}>
                        <DropDownButtonItem
                            text={localizationService.toLanguageString("OdoFRM.Vytlačiť kópiu dodacieho listu", "Vytlačiť kópiu dodacieho listu")}
                        />
                        <DropDownButtonItem
                            text={localizationService.toLanguageString("OdoFRM.Vytlačiť kópiu štítku na balík", "Vytlačiť kópiu štítku na balík")}
                        />
                        <DropDownButtonItem
                            text={localizationService.toLanguageString("OdoFRM.Vytlačiť kópiu GLS štítku na balík", "Vytlačiť kópiu GLS štítku na balík")}
                            disabled={this.state.selectedSposobDopravy != SposobDopravy.GLS}
                        />
                        <DropDownButtonItem
                            text={localizationService.toLanguageString(
                                "OdoFRM.Vytlačiť kópiu súhrnného dodacieho listu",
                                "Vytlačiť kópiu súhrnného dodacieho listu"
                            )}
                        />
                        <DropDownButtonItem
                            text={localizationService.toLanguageString(
                                "OdoFRM.Vytlačiť kópiu potvrdenia o prevzatí dodávky tovaru",
                                "Vytlačiť kópiu potvrdenia o prevzatí dodávky tovaru"
                            )}
                        />
                        <DropDownButtonItem
                            text={localizationService.toLanguageString(
                                "OdoFRM.Vytlačiť kópiu dodacieho listu pre odoslanie tovaru",
                                "Vytlačiť kópiu dodacieho listu pre odoslanie tovaru"
                            )}
                        />
                        <DropDownButtonItem text={localizationService.toLanguageString("OdoFRM.Upraviť neexpedovaný balík", "Upraviť neexpedovaný balík")} />
                        <DropDownButtonItem
                            text={localizationService.toLanguageString("OdoFRM.Odstrániť neexpedovaný balík", "Odstrániť neexpedovaný balík")}
                        />
                        <DropDownButtonItem text={localizationService.toLanguageString("OdoFRM.Odstrániť expedíciu tovaru", "Odstrániť expedíciu tovaru")} />
                        <DropDownButtonItem
                            text={localizationService.toLanguageString(
                                "OdoFRM.Vygenerovať chýbajúcu správu pre expedíciu",
                                "Vygenerovať chýbajúcu správu pre expedíciu"
                            )}
                            disabled={!authenticationService.hasCurrentUserRole(RoleNames.Administrator)}
                        />
                    </DropDownButton>
                </div>
                <DialogWindow dialog={this.state.dialog} />
                <PdfViewer show={this.state.pdfShow} loading={this.state.pdfLoading} print={this.state.pdfPrint} pdfFile={this.state.pdfFile} />
            </React.Fragment>
        );

        return <div>{contents}</div>;
    }
}

export default OdoslanieBaliky;

registerForLocalization(OdoslanieBaliky);



// WEBPACK FOOTER //
// ./src/components/dialogs/OdeslaniTovaru/OdoslanieBaliky.js